module.exports = __webpack_public_path__ + "/3ea5381577ac8159212d7d7c3b71673b.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/assets/screenshot_dropbox.png
 ** module id = 841
 ** module chunks = 0
 **/